/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';

/**
 * 
 * @export
 * @interface ClientPaymentDto
 */
export interface ClientPaymentDto {
    /**
     * 
     * @type {PaymentProvider}
     * @memberof ClientPaymentDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    pspReference?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientPaymentDto
     */
    executingLocationId: number;
    /**
     * 
     * @type {ClientPaymentDtoLatestEventCodeEnum}
     * @memberof ClientPaymentDto
     */
    latestEventCode: ClientPaymentDtoLatestEventCodeEnum;
    /**
     * 
     * @type {ClientPaymentDtoLatestStateEnum}
     * @memberof ClientPaymentDto
     */
    latestState: ClientPaymentDtoLatestStateEnum;
    /**
     * 
     * @type {ClientPaymentDtoCurrencyEnum}
     * @memberof ClientPaymentDto
     */
    currency: ClientPaymentDtoCurrencyEnum;
    /**
     * 
     * @type {number}
     * @memberof ClientPaymentDto
     */
    grossAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClientPaymentDto
     */
    paymentFeeAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClientPaymentDto
     */
    commissionAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClientPaymentDto
     */
    netAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClientPaymentDto
     */
    terminalTipAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClientPaymentDto
     */
    grossAmountAfterAddingTerminalTip: number;
    /**
     * 
     * @type {number}
     * @memberof ClientPaymentDto
     */
    refundedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClientPaymentDto
     */
    refundableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClientPaymentDto
     */
    pendingRefundAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClientPaymentDto
     */
    refundedAndPendingRefundAmount: number;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    paymentSplitStatuses: string;
    /**
     * 
     * @type {Date}
     * @memberof ClientPaymentDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClientPaymentDto
     */
    updated?: Date;
}


/**
 * @export
 */
export const ClientPaymentDtoLatestEventCodeEnum = {
    INITIATE: 'INITIATE',
    INITIATE_FAILED: 'INITIATE_FAILED',
    SEND_FOR_PAYMENT: 'SEND_FOR_PAYMENT',
    REDIRECT_SHOPPER: 'REDIRECT_SHOPPER',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    COMPLETE_WITHOUT_PAYMENT: 'COMPLETE_WITHOUT_PAYMENT',
    AUTHORISE: 'AUTHORISE',
    AUTHORISE_FAILED: 'AUTHORISE_FAILED',
    AUTHORISE_SUCCEEDED: 'AUTHORISE_SUCCEEDED',
    CAPTURE: 'CAPTURE',
    CAPTURE_SUCCEEDED: 'CAPTURE_SUCCEEDED',
    CAPTURE_FAILED: 'CAPTURE_FAILED',
    REFUND: 'REFUND',
    REFUND_SUCCEEDED: 'REFUND_SUCCEEDED',
    REFUND_FAILED: 'REFUND_FAILED',
    STATE_UNDETERMINED: 'STATE_UNDETERMINED',
    STATE_IN_PROGRESS: 'STATE_IN_PROGRESS',
    MANUAL_STATE_OVERRIDE: 'MANUAL_STATE_OVERRIDE'
} as const;
export type ClientPaymentDtoLatestEventCodeEnum = typeof ClientPaymentDtoLatestEventCodeEnum[keyof typeof ClientPaymentDtoLatestEventCodeEnum];

/**
 * @export
 */
export const ClientPaymentDtoLatestStateEnum = {
    INITIATING: 'INITIATING',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    AUTHORISING: 'AUTHORISING',
    AUTHORISED: 'AUTHORISED',
    CAPTURING: 'CAPTURING',
    CAPTURED: 'CAPTURED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    FULLY_REFUNDED: 'FULLY_REFUNDED',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    REFUNDING: 'REFUNDING'
} as const;
export type ClientPaymentDtoLatestStateEnum = typeof ClientPaymentDtoLatestStateEnum[keyof typeof ClientPaymentDtoLatestStateEnum];

/**
 * @export
 */
export const ClientPaymentDtoCurrencyEnum = {
    NOK: 'NOK',
    DKK: 'DKK',
    SEK: 'SEK',
    GBP: 'GBP'
} as const;
export type ClientPaymentDtoCurrencyEnum = typeof ClientPaymentDtoCurrencyEnum[keyof typeof ClientPaymentDtoCurrencyEnum];


/**
 * Check if a given object implements the ClientPaymentDto interface.
 */
export function instanceOfClientPaymentDto(value: object): value is ClientPaymentDto {
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('orderReference' in value) || value['orderReference'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('latestEventCode' in value) || value['latestEventCode'] === undefined) return false;
    if (!('latestState' in value) || value['latestState'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('grossAmount' in value) || value['grossAmount'] === undefined) return false;
    if (!('paymentFeeAmount' in value) || value['paymentFeeAmount'] === undefined) return false;
    if (!('commissionAmount' in value) || value['commissionAmount'] === undefined) return false;
    if (!('netAmount' in value) || value['netAmount'] === undefined) return false;
    if (!('terminalTipAmount' in value) || value['terminalTipAmount'] === undefined) return false;
    if (!('grossAmountAfterAddingTerminalTip' in value) || value['grossAmountAfterAddingTerminalTip'] === undefined) return false;
    if (!('refundedAmount' in value) || value['refundedAmount'] === undefined) return false;
    if (!('refundableAmount' in value) || value['refundableAmount'] === undefined) return false;
    if (!('pendingRefundAmount' in value) || value['pendingRefundAmount'] === undefined) return false;
    if (!('refundedAndPendingRefundAmount' in value) || value['refundedAndPendingRefundAmount'] === undefined) return false;
    if (!('paymentSplitStatuses' in value) || value['paymentSplitStatuses'] === undefined) return false;
    return true;
}

export function ClientPaymentDtoFromJSON(json: any): ClientPaymentDto {
    return ClientPaymentDtoFromJSONTyped(json, false);
}

export function ClientPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientPaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'orderReference': json['orderReference'],
        'paymentReference': json['paymentReference'],
        'pspReference': json['pspReference'] == null ? undefined : json['pspReference'],
        'executingLocationId': json['executingLocationId'],
        'latestEventCode': json['latestEventCode'],
        'latestState': json['latestState'],
        'currency': json['currency'],
        'grossAmount': json['grossAmount'],
        'paymentFeeAmount': json['paymentFeeAmount'],
        'commissionAmount': json['commissionAmount'],
        'netAmount': json['netAmount'],
        'terminalTipAmount': json['terminalTipAmount'],
        'grossAmountAfterAddingTerminalTip': json['grossAmountAfterAddingTerminalTip'],
        'refundedAmount': json['refundedAmount'],
        'refundableAmount': json['refundableAmount'],
        'pendingRefundAmount': json['pendingRefundAmount'],
        'refundedAndPendingRefundAmount': json['refundedAndPendingRefundAmount'],
        'paymentSplitStatuses': json['paymentSplitStatuses'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
    };
}

export function ClientPaymentDtoToJSON(json: any): ClientPaymentDto {
    return ClientPaymentDtoToJSONTyped(json, false);
}

export function ClientPaymentDtoToJSONTyped(value?: ClientPaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'orderReference': value['orderReference'],
        'paymentReference': value['paymentReference'],
        'pspReference': value['pspReference'],
        'executingLocationId': value['executingLocationId'],
        'latestEventCode': value['latestEventCode'],
        'latestState': value['latestState'],
        'currency': value['currency'],
        'grossAmount': value['grossAmount'],
        'paymentFeeAmount': value['paymentFeeAmount'],
        'commissionAmount': value['commissionAmount'],
        'netAmount': value['netAmount'],
        'terminalTipAmount': value['terminalTipAmount'],
        'grossAmountAfterAddingTerminalTip': value['grossAmountAfterAddingTerminalTip'],
        'refundedAmount': value['refundedAmount'],
        'refundableAmount': value['refundableAmount'],
        'pendingRefundAmount': value['pendingRefundAmount'],
        'refundedAndPendingRefundAmount': value['refundedAndPendingRefundAmount'],
        'paymentSplitStatuses': value['paymentSplitStatuses'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'updated': value['updated'] == null ? value['updated'] : value['updated'].toISOString(),
    };
}

